export const InitialState = {
    id: null,
    viewState: 0,

    mainData: {},
    mainDataChanged: false,

    revisionsInfo: [],
    hasRevisions: false,
};

